export enum PAGES {
  amount = 'amount',
  confirmation = 'confirmation',
  congrats = 'congrats',
  error = 'error',
  loading = 'loading',
  pricingPlan = 'pricing-plan',
}

// TODO: Get these values from the back end
export const SUGGESTED_DAILY = [25, 50, 100, 200];
export const SUGGESTED_WEEKLY = [100, 250, 500, 1000];
export const SUGGESTED_BI_MONTHLY = [250, 500, 1000, 2500];
export const SUGGESTED_MONTHLY = [500, 1000, 2500, 5000];
